/* MUI */
import { useTheme } from '@mui/material/styles';

/* React */
import React from 'react';

export const CustomizedDot = ({
    cx,
    cy,
    dynamicBorderColorsFn,
    dynamicColorsFn,
    payload,
    circleWidth,
    dataKey,
    fontSize,
    opacity,
    showText,
    matchBorder
}) => {
    const theme = useTheme();
    if (!cx || !cy) {
        return null;
    }

    const circleOpacity = opacity || 1;
    const opaque = circleOpacity !== 1;

    let circleColor = theme.palette.customizedDot.color;
    if (dynamicColorsFn) {
        circleColor = dynamicColorsFn(payload[dataKey], opaque);
    }

    let circleBorder = theme.palette.customizedDot.border;
    if (dynamicBorderColorsFn) {
        circleBorder = dynamicBorderColorsFn(payload[dataKey]);
    }

    let textValue = payload[dataKey];
    let renderedCircleWidth = circleWidth;
    if (!textValue) {
        renderedCircleWidth = 0;
        textValue = '';
    }

    return (
        <g transform={`translate(${cx},${cy})`}>
            <circle
                cx={0}
                cy={0}
                r={renderedCircleWidth}
                stroke={matchBorder ? circleColor : circleBorder}
                strokeWidth={1}
                strokeOpacity={circleOpacity}
                fill={circleColor}
                style={{
                    circleOpacity
                }}
            />
            {showText && (
                <text
                    x={0}
                    y={1}
                    stroke={theme.palette.text.black}
                    strokeWidth={0.5}
                    textAnchor="middle"
                    alignmentBaseline="middle"
                    style={{
                        fontFamily: "'Open Sans'",
                        fontSize
                    }}
                >
                    {textValue}
                </text>
            )}
        </g>
    );
};
